const n = (a) => {
  const e = {
    regular: {
      height: a * 2.75,
      // height of input
      marginTop: a * 0.5,
      // extra space when label is on top of input
      marginBottom: a * 1.5,
      // extra space for message comes on bottom of input
      paddingLeft: a,
      paddingRight: a * 0.75,
      borderRadius: a * 0.5,
      inputTextVariant: "body1",
      labelTextVariant: "body1",
      messageTextVariant: "body3",
      iconsize: a * 1.5,
      iconPadding: a
      // padding between left of icon and input
    },
    small: {
      height: a * 2.125,
      // height of input
      marginTop: a * 0.5,
      // extra space when label is on top of input
      marginBottom: 0,
      // extra space for message comes on bottom of input
      paddingLeft: a * 0.5,
      paddingRight: a * 0.5,
      borderRadius: a * 0.5,
      inputTextVariant: "body3",
      labelTextVariant: "body3",
      messageTextVariant: "body3",
      iconsize: a * 1.25,
      iconPadding: a * 0.5
      // padding between left of icon and input
    },
    xsmall: {
      height: a * 1.75,
      // height of input
      marginTop: 0,
      // extra space when label is on top of input
      marginBottom: 0,
      // extra space for message comes on bottom of input
      paddingLeft: a * 0.75,
      paddingRight: a * 0.5,
      borderRadius: a * 0.5,
      inputTextVariant: "body3",
      labelTextVariant: "body3",
      messageTextVariant: "body3",
      iconsize: a,
      iconPadding: a * 0.5
      // padding between left of icon and input
    }
  }, i = {
    valueColorName: {
      inactive: "BLACK",
      active: "BLACK",
      disabled: "BLACK_50"
    },
    borderColorName: {
      inactive: "BLACK_T_15",
      active: "BLACK_T_87",
      disabled: "BLACK_T_15"
    },
    labelColorName: {
      inactive: "BLACK_75",
      active: "BLACK",
      disabled: "BLACK_50"
    },
    messageColorName: {
      inactive: "BLACK_75",
      active: "BLACK_75",
      disabled: "BLACK_50"
    },
    opacity: {
      disabled: 0.5,
      enabled: 1
    }
  }, o = {
    ...i,
    backgroundColorName: "GREY_1",
    optionHoverColorName: "WHITE",
    borderColorName: {
      active: "TRANSPARENT",
      inactive: "TRANSPARENT",
      disabled: "TRANSPARENT"
    }
  }, d = {
    primary: i,
    secondary: o,
    success: {
      opacity: i.opacity,
      valueColorName: i.valueColorName,
      borderColorName: {
        inactive: "GREEN_5",
        active: "GREEN_5",
        disabled: "GREEN_5"
      },
      labelColorName: {
        inactive: "GREEN_5",
        active: "GREEN_5",
        disabled: "GREEN_5"
      },
      messageColorName: {
        inactive: "GREEN_5",
        active: "GREEN_5",
        disabled: "GREEN_5"
      }
    },
    error: {
      opacity: i.opacity,
      valueColorName: i.valueColorName,
      borderColorName: {
        inactive: "RED",
        active: "RED",
        disabled: "RED"
      },
      labelColorName: {
        inactive: "RED",
        active: "RED",
        disabled: "RED"
      },
      messageColorName: {
        inactive: "RED",
        active: "RED",
        disabled: "RED"
      }
    }
  };
  return { sizes: e, variants: d };
};
export {
  n as default
};
//# sourceMappingURL=input.js.map
